
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/policy-two",
      function () {
        return require("private-next-pages/de/policy-two.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/policy-two"])
      });
    }
  